import {IEService} from "@ispm/shared/services/IE.service";

export class ErrorHandler {

  //This function checks if browser is IE, and if so changes console errors to alerts
  public static consoleErrorToAlert(){
    if (IEService.runIECheck() && localStorage.getItem("errorToAlert")){
      console.error = function(msg) {
        try {
          throw new Error('alert')
        } catch(e) {
          window.alert(msg + "\n" + e.stack);
        }
      }
    }
  }
}
